import React, { useState } from "react";
import "./Stepper.css";
import box_img from "../../../assets/images/box-search-img.svg"
import arrow_img from "../../../assets/images/steps-arrow.svg"

const auditData = [
    {
        id: 1,
        select_opt: <>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
            </div>
        </>,
        res_no: "1170",
        guest: "Sounder",
        room: "103",
        rate_type: "Room Only",
        source: "PMS",
        departure: "07/10/2025",
        total: "2300.00",
        deposit: "2300.00"
    },
]

const NightAudit = () => {

    const steps = [
        "Pending Reservation",
        "Release Reservation",      
        "Room Status",
        "Unsettled Folios",
        "Nightly Charge",
        "Create New day",
    ];

    const [activeStep, setActiveStep] = useState(1);

    const handleNext = () => {
        if (activeStep < steps.length) {
            setActiveStep((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        if (activeStep > 1) {
            setActiveStep((prev) => prev - 1);
        }
    };

    return (
        <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
            <div className="row mb-3">
                <div className="col-sm-12">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <h3 className="fw-bold mb-4">Night Audit</h3>
                    </div>

                    <div className="stepper-wrapper">
                        {/* Steps Header */}
                        <div className="steps-container">
                            {steps.map((label, index) => {
                                const stepNumber = index + 1;
                                const isActive = stepNumber <= activeStep;

                                return (
                                    <>
                                        <div className="step-wrapper" key={index}>
                                            <div className="step-item">
                                                <div className={`step-circle ${isActive ? "active" : ""}`}>
                                                    {stepNumber < 10 ? `0${stepNumber}` : stepNumber}
                                                </div>
                                                <p className="step-label text-nowrap">{label}</p>
                                            </div>
                                        </div>
                                        <div>
                                             {index !== steps.length - 1 && (
                                                <img src={arrow_img} className="steps-arrow-img" alt="arrow_img" />
                                            )}
                                        </div>
                                    </>
                                );
                            })}
                        </div>

                        {/* Step Content */}
                        <div className="step-content mt-4">
                            {activeStep === 1 && (
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-hover">
                                                        <thead>
                                                            <tr className="small text-uppercase">
                                                                <th></th>
                                                                <th>Res No#</th>
                                                                <th>Guest</th>
                                                                <th>Room</th>
                                                                <th>Rate Type</th>
                                                                <th>Source</th>
                                                                <th>Departure</th>
                                                                <th>Total(Rs)</th>
                                                                <th>Deposit(Rs)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {auditData.map((data, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{data.select_opt}</td>
                                                                        <td>{data.res_no}</td>
                                                                        <td>{data.guest}</td>
                                                                        <td>{data.room}</td>
                                                                        <td>{data.rate_type}</td>
                                                                        <td>{data.source}</td>
                                                                        <td>{data.departure}</td>
                                                                        <td>{data.total}</td>
                                                                        <td>{data.deposit}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {activeStep === 2 && (
                                <div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table table-hover">
                                                            <thead>
                                                                <tr className="small text-uppercase">
                                                                    <th></th>
                                                                    <th>Res No#</th>
                                                                    <th>Guest</th>
                                                                    <th>Room</th>
                                                                    <th>Rate Type</th>
                                                                    <th>Source</th>
                                                                    <th>Departure</th>
                                                                    <th>Total(Rs)</th>
                                                                    <th>Deposit(Rs)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {auditData.map((data, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{data.select_opt}</td>
                                                                            <td>{data.res_no}</td>
                                                                            <td>{data.guest}</td>
                                                                            <td>{data.room}</td>
                                                                            <td>{data.rate_type}</td>
                                                                            <td>{data.source}</td>
                                                                            <td>{data.departure}</td>
                                                                            <td>{data.total}</td>
                                                                            <td>{data.deposit}</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {activeStep === 3 && (
                                <div>
                                    <div className="step-sub-content3">
                                        <img src={box_img} alt="box_img" />
                                    </div>
                                </div>
                            )}
                            {activeStep === 4 && (
                                <div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table table-hover">
                                                            <thead>
                                                                <tr className="small text-uppercase">
                                                                    <th></th>
                                                                    <th>Res No#</th>
                                                                    <th>Guest</th>
                                                                    <th>Room</th>
                                                                    <th>Rate Type</th>
                                                                    <th>Source</th>
                                                                    <th>Departure</th>
                                                                    <th>Total(Rs)</th>
                                                                    <th>Deposit(Rs)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {auditData.map((data, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{data.select_opt}</td>
                                                                            <td>{data.res_no}</td>
                                                                            <td>{data.guest}</td>
                                                                            <td>{data.room}</td>
                                                                            <td>{data.rate_type}</td>
                                                                            <td>{data.source}</td>
                                                                            <td>{data.departure}</td>
                                                                            <td>{data.total}</td>
                                                                            <td>{data.deposit}</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {activeStep === 5 && (
                                <div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table table-hover">
                                                            <thead>
                                                                <tr className="small text-uppercase">
                                                                    <th></th>
                                                                    <th>Res No#</th>
                                                                    <th>Guest</th>
                                                                    <th>Room</th>
                                                                    <th>Rate Type</th>
                                                                    <th>Source</th>
                                                                    <th>Departure</th>
                                                                    <th>Total(Rs)</th>
                                                                    <th>Deposit(Rs)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {auditData.map((data, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{data.select_opt}</td>
                                                                            <td>{data.res_no}</td>
                                                                            <td>{data.guest}</td>
                                                                            <td>{data.room}</td>
                                                                            <td>{data.rate_type}</td>
                                                                            <td>{data.source}</td>
                                                                            <td>{data.departure}</td>
                                                                            <td>{data.total}</td>
                                                                            <td>{data.deposit}</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {activeStep === 6 && (
                                <div>
                                    <div className="step-sub-content6">
                                        <p className="m-0">Hotel Will Move To New Day.</p>
                                        <input type="date" class="me-2" value="2025-10-06"></input>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Buttons */}
                        <div className="actions">
                            <button onClick={handlePrev} disabled={activeStep === 1}>
                                Previous
                            </button>
                            <button onClick={handleNext}>
                                {activeStep === steps.length ? "Finish" : "Next"}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default NightAudit